import httpUtils from '../../utils/HttpUtils'
import session from '../../utils/Session'

class UserService {

  //手机号码登录
  async phoneLogin (phone = '') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/user/phone/login',{phone});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }
  //手机号码登录
  async wechatLogin (openid = '') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/user/wechat/login',{openid});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //用户名密码登录
  async passwordLogin (phone = '',password = '') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/user/password/login',{phone,password});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  /**
   * 获取用户openId
   * @returns {*}
   */
  async getAccessToken(code = ''){
    console.log('获取用户AccessToken,  code=' + code);
    var result = null;
    try {
      result = await httpUtils.get('/wechat/accessToken', {code});
      console.log('/wechat/accessToken ==> result', result)
    } catch (e) {
      console.error('获取用户AccessToken失败', e);
      result = {code: 1, msg: '网络异常，请重试'}
    }
    return result
  }

  //获取用户信息
  async getUserInfo () {
    console.log('获取用户信息');
    var result = null;
    try {
      result = await httpUtils.post('/customer/user/profile');
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //校验用户是否注册
  async checkRegister (phone = '',operationType = '') {
    let result = null;
    try {
      result = await httpUtils.post('/customer/user/check/register',{phone,operationType});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //新用户注册
  async register (phone = '',password = '') {
    let result = null;
    try {
      result = await httpUtils.post('/customer/user/register',{phone,password});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //修改密码
  async modifyPassword (phone = '',password = '') {
    let result = null;
    try {
      result = await httpUtils.post('/customer/user/modify/password',{phone,password});
    } catch (e) {
      console.log('连接失败', e);
      result = {code: 1, msg: '连接失败'}
    }
    return result
  }

  //获取微信信息
  async getWxUserInfo() {
    var result = null;
    try {
      var accessToken = session.getAccessToken();
      result = await httpUtils.post('/wechat/userinfo', accessToken)
    } catch (e) {
      result = {code: 1, msg: '网络异常，请重试'}
    }
    return result
  }

  //校验是否授权登录系统
  async checkWechatRegister(unionId = '',openId = '') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/user/check/wechat/register', {unionId,openId})
    } catch (e) {
      result = {code: 1, msg: '网络异常，请重试'}
    }
    return result
  }

  //用户绑定手机号
  async bindPhone(unionid = '',openid = '',phone = '',nickname = '',avatarUrl = '',userType = '') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/user/bind/phone', {unionid,openid,phone,nickname,avatarUrl,userType })
    } catch (e) {
      result = {code: 1, msg: '网络异常，请重试'}
    }
    return result
  }
  //用户绑定手机号
  async modifyInfo(nickname = '') {
    var result = null;
    try {
      result = await httpUtils.post('/customer/user/modify/user/info', {nickname })
    } catch (e) {
      result = {code: 1, msg: '网络异常，请重试'}
    }
    return result
  }
}
export default new UserService()
